import { render } from "./FeedbackOne.vue?vue&type=template&id=61c4be48"
import script from "./FeedbackOne.vue?vue&type=script&lang=js"
export * from "./FeedbackOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__